import React from "react";
import {connect} from "react-redux";
import {replace} from 'react-router-redux'
import {Row, Col, Button, Form, Modal} from "react-bootstrap";
import ModalPopup from"../../components/common/ModalPopup";
import StoreCart from "../../components/store/StoreCart";
import UserMenu from "../common/UserMenu";
import PaymentMethods from "../../components/pay/PaymentMethods";
import {translate} from "../../i18n/translate";
import {FetchingTypes, PaymentMethod, URLs} from "../../common/constants";
import {removePath} from '../../common/utils';
import {orderValidator, getRemainingCredits} from '../../common/basket.js';
import {submitOrder, setUnavailableItemsInOrder} from "../../actions/store/storeCheckoutActions";
import {getStoreDataAndSubmit} from "../../actions/store/storeActions";
import {isFetching} from "../../actions/common/fetchingActions";
import RecurringOrderItems from "./RecurringOrderItems";
import styles from "../../css/store/storeCheckout.less";

class StoreCheckOutScreen extends React.Component {
    state = {
        storeComments: this.props.storeComments,
        showModal: true,
    };

    handleStoreCommentsChange = (event) => {
		this.setState({storeComments: event.target.value});
	};

    getStorePaymentMethodText = (usedCreditsOnly) => {
        if (this.hasBalanceMethod())
            return this.props.staticData.storeCheckoutMessageBalance || translate("_CheckOutMessageBalance");

        if (this.props.creditsData.credits > 0 && usedCreditsOnly)
            return translate("_CheckOutMessageNone").replace("_FARM_NAME_", this.props.staticData.farmName);

        if (this.props.staticData.storePaymentMethods.includes((this.props.isZeroAmount || (this.hasPreapprovalForCheckout() && this.isAutoRenewalMethods())) ? this.props.paymentMethodToken : this.state.selectedMethod))
            return translate('ON_DELIVERY_CHARGE_hasToken');

        if (this.props.isZeroAmount)
            return translate('_chargeHasTokenZeroAmount');

        return "";
	};

    onSubmitButtonClick = () => {
	    this.setState({placeOrderClicked: true});
        let selectedMethod = (this.props.isZeroAmount || (this.hasPreapprovalForCheckout() && this.isAutoRenewalMethods())) ? PaymentMethod.NONE.key : this.state.selectedMethod;
		this.props.getStoreDataAndSubmit(this.props.staticData, this.props.memberKey, this.props.subscriptionKey, this.props.orderKey, this.props.itemsList, this.props.activeOrder, this.props.canEditExistingOrder, this.props.hasPreapproval, this.state.storeComments, selectedMethod);
	};

    setSelectedMethod = (key) => {
        this.setState({selectedMethod:key});
	};

    isPlaceOrderButtonDisabled = () => {
        const isBalance = this.props.staticData.storePaymentMethods.length === 1 && this.props.staticData.storePaymentMethods.includes("BALANCE");
        let selectedMethod = (this.props.isZeroAmount || (this.hasPreapprovalForCheckout() && this.isAutoRenewalMethods())) ? this.props.paymentMethodToken : this.state.selectedMethod;
        return this.state.placeOrderClicked || (this.props.showLoading) || (!this.props.staticData.storePaymentMethods.includes(selectedMethod) && !this.props.isZeroAmount && !isBalance) || this.props.isNegativeAmount;
    };

    getUnAvailableMessage = () => {
        let itemsTitles = "";
        const unAvailableItems = this.props.unAvailableItems;
        Object.keys(unAvailableItems).forEach(function(key, index){
            if(index === Object.keys(unAvailableItems).length-1){
                itemsTitles += unAvailableItems[key].title + ".";

            }else {
                itemsTitles += unAvailableItems[key].title + ", ";
            }
        });
        const validationMessage = orderValidator.validateMinimumPerOrder(this.props.itemsList,
            this.props.staticData.minimumPerOrder, this.props.extraCost, this.props.extraCostType, this.props.creditsData.credits, this.props.staticData,
            this.props.shareItems);
        //User can continue if there are still items and no message
        const canCheckout = this.props.isOrderChanged && !validationMessage;
        const message = !canCheckout ? (translate("_ItemShort") + itemsTitles
                                        + (validationMessage ? validationMessage : "")
                                        + translate("_returnToStoreToUpdateYourOrder"))
            : translate("_ItemShort")
                    + itemsTitles
                    + translate("_checkoutWithTheAvailableItems");

        if(this.state.showModal) {
            return (
                <ModalPopup
                    onClose={this.closeModal}
                    title={!this.props.isOrderChanged ? "_OrderWasntCreated" : undefined}
                    message={message}
                    middle={!canCheckout ? {text:'returnToStore', callback:this.goBackUnAvailableFlow} : undefined}
                    right={canCheckout ? {text:'Checkout', callback:this.continueToPayment} : undefined}
                    left={canCheckout ? {text:'returnToStore', callback:this.goBackUnAvailableFlow} : undefined}/>
            );
        }
    };

    continueToPayment = () => {
        this.props.unsetUnavailableItems();
        this.props.submitOrder(this.props.staticData, this.props.memberKey, this.props.subscriptionKey, this.props.orderKey, this.props.itemsList, this.props.activeOrder, this.props.canEditExistingOrder, this.props.hasPreapproval, this.state.storeComments, this.state.selectedMethod);
    };

    goBackUnAvailableFlow = () => {
        this.props.unsetUnavailableItems();
        this.props.goBack();
    };

    hasPreapprovalForCheckout = () => {
        return this.props.hasPreapproval;
    };

    isAutoRenewalMethods = () => {
        const methods = this.props.staticData.storePaymentMethods.filter(method => {
            return (method === PaymentMethod.PAYPAL_PREAPPROVE.key || method === PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key || method === PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key)
        });
        return methods.length > 0;
    };

    hasBalanceMethod = () => {
        const methods = this.props.staticData.storePaymentMethods.filter(method => method === PaymentMethod.BALANCE.key);
        return methods.length > 0;
    };

    getUpdateRecurringModal = () => {
        if(this.props.showUpdateRecurringModal) {
            return (<Modal show={true} dialogClassName="update-recurring-items">
                <Modal.Body>
                    <RecurringOrderItems readOnly={true}/>
                </Modal.Body>
            </Modal>);
        }
    };

    render() {
        const staticData = this.props.staticData;
        const itemsList = this.props.itemsList;
        const placeOrderText = (this.props.staticData.storeCheckoutButtonLabel || ('|' + translate("Place Order") + '|')).split('|')[1];
        const finalizeOrderText = (this.props.staticData.storeCheckoutButtonLabel || ('||' + translate("Finalize Your Order"))).split('|')[2];
        const submitLoadingClass = this.props.showLoading ? " loading" : "";
        const submitClasses = "submit-order button" + submitLoadingClass;
        const usedCreditsOnly = this.props.creditsData.credits > 0 && this.props.isZeroAmount;
        return (<Form>
            <fieldset disabled={this.props.showLoading} className="container-fluid">
                <Row>
                    <Col className="checkout-wrapper" md={8} xs={12} sm={12}>
                        <Row className="checkout-header">
                            <Col md={5} sm={5}>
                                <h1>{finalizeOrderText}</h1>
                                <a className="back-to-store hidden-sm hidden-md hidden-lg"
                                   onClick={this.props.goBack}><i/></a>
                            </Col>
                            <Col md={7} className="actions-col hidden-xs">
                                <a className="back-to-store" disabled={this.props.showLoading}
                                   onClick={this.props.showLoading ? (() => {
                                       }) : this.props.goBack}>{translate("Back to store")}</a>

                                <Button bsStyle="primary" className={submitClasses} onClick={this.onSubmitButtonClick}
                                        disabled={this.isPlaceOrderButtonDisabled(this.props.isZeroAmount)}>{placeOrderText}</Button>
                                <UserMenu/>
                            </Col>
                        </Row>
                        <Row>
                            <div className="checkout-content">
                                {!this.hasBalanceMethod() && !this.props.isZeroAmount && (!this.hasPreapprovalForCheckout() || (this.hasPreapprovalForCheckout() && !this.isAutoRenewalMethods())) ?

                                    <PaymentMethods paymentMethods={this.props.staticData.storePaymentMethods}
                                                    setSelectedMethod={this.setSelectedMethod}
                                                    selectedMethod={this.state.selectedMethod}
                                                    pageContext={URLs.STORE}/>
                                    : <span className="store-payment-method-text"
                                            dangerouslySetInnerHTML={{__html: this.getStorePaymentMethodText(usedCreditsOnly)}}/>
                                }
                                {
                                    staticData.storeCommentsLabel && staticData.storeCommentsLabel != 'null' ?
                                        <div className="text-area">
                                            <div className="store-comment-label"
                                                 dangerouslySetInnerHTML={{__html: staticData.storeCommentsLabel}}/>
                                            <textarea className="input-text" type="text" rows="3"
                                                      value={this.state.storeComments}
                                                      onChange={this.handleStoreCommentsChange}/>
                                        </div>
                                        : undefined
                                }
                                <Row className="checkout-bottom">
                                    <Col md={8} sm={12} xs={12} className="terms-wrapper">
                                    <span
                                        className="terms-agreement">{translate("By clicking ")}<b>{placeOrderText}</b> {translate("_agreeToTerms") + " "}
                                        <a href={staticData.termsUrl} target="_blank">{staticData.farmName}</a>
                                    </span>
                                    </Col>
                                    <Col md={4} sm={12} xs={12} className="submit-wrapper">
                                        <Button bsStyle="primary" className={submitClasses}
                                                onClick={this.onSubmitButtonClick}
                                                disabled={this.isPlaceOrderButtonDisabled(this.props.isZeroAmount)}>{placeOrderText}</Button>
                                    </Col>
                                </Row>
                            </div>
                        </Row>
                    </Col>
                    <Col md={4} className="summary-order-wrapper hidden-xs hidden-sm">
                        <StoreCart items={itemsList}
                                   orderedItems={this.props.orderedItems}
                                   extraCreditItem={this.props.extraCreditItem}
                                   totals={this.props.totals}
                                   remainingCredits={getRemainingCredits(this.props.creditsData, this.props.totals)}
                                   staticData={this.props.staticData}
                                   creditsData={this.props.creditsData}
                                   creditItemLabel={this.props.creditItemLabel}
                                   readonly={true}/>
                    </Col>
                    <Col md={12}>
                        {this.props.unAvailableItems && Object.keys(this.props.unAvailableItems).length > 0 ? this.getUnAvailableMessage() : undefined}
                    </Col>
                </Row>
            </fieldset>
            {this.getUpdateRecurringModal()}
        </Form>);
    }
}

//export default StoreItemsScreen;

const mapStateToProps = (state) => {
	const status = (state.orderStatus || {});
	const summary = state.summary || {};
    const staticData = (state.staticData || {});
	return {
        showLoading: isFetching(state, FetchingTypes.SUBMIT),
        itemsList: state.itemsList,
        shareItems: summary.shareItems,
		orderKey: status.orderKey,
        subscriptionKey: summary.key,
        hasPreapproval: summary.hasPreapproval,
        storeComments: status.comments,
		canEditExistingOrder: summary.canEditExistingOrder,
		activeOrder: status.activeOrder,
		memberKey: (state.memberDetails || {}).key,
		staticData: staticData,
        unAvailableItems: (state.checkout || {}).unAvailableItems,
        isOrderChanged: (state.orderStatus || {}).isChanged,
        isZeroAmount: ((status.totals || {}).orderTotal || {}).fullPrice === 0,
        isNegativeAmount: ((status.totals || {}).orderTotal || {}).fullPrice < 0,
        totals: (status.totals || {}),
        extraCost: summary.extraCost,
        extraCostType: summary.extraCostType,
        paymentMethodToken: summary.paymentMethodToken,
        creditsData: (state.storeCreditsData || {}),
        orderedItems: status.orderedItems,
        extraCreditItem: ((state.storeCreditsData || {}).extraCreditItem || {}),
        creditItemLabel: staticData.creditItemLabel,
        showUpdateRecurringModal: (state.recurringOrder || {}).showUpdateRecurringModal
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
        getStoreDataAndSubmit: (staticData, memberKey, subscriptionKey, orderKey, itemsList, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method) => {
			dispatch(getStoreDataAndSubmit(staticData, memberKey, subscriptionKey, orderKey, itemsList, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method, ownProps.staticData.isChargeOnDelivery));
		},
        submitOrder: (staticData, memberKey, subscriptionKey, orderKey, itemsList, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method) => {
            dispatch(submitOrder(memberKey, subscriptionKey, orderKey, itemsList, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method, ownProps.staticData.isChargeOnDelivery));
        },
        goBack: () => {
            dispatch(replace(removePath("checkout")));
        },
        unsetUnavailableItems: () => {
            dispatch(setUnavailableItemsInOrder(undefined));
        },
	}
};

export default connect(mapStateToProps, mapDispatchToProps)( StoreCheckOutScreen );


// WEBPACK FOOTER //
// ./src/containers/store/StoreCheckOutScreen.js